import React from 'react';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import CurrencyRupeeRoundedIcon from '@mui/icons-material/CurrencyRupeeRounded';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import PercentRoundedIcon from '@mui/icons-material/PercentRounded';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import RoomOutlinedIcon from '@mui/icons-material/RoomOutlined';
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined';
import SellOutlinedIcon from '@mui/icons-material/SellOutlined';
import StraightenOutlinedIcon from '@mui/icons-material/StraightenOutlined';
import ScaleOutlinedIcon from '@mui/icons-material/ScaleOutlined';
import ViewInArOutlinedIcon from '@mui/icons-material/ViewInArOutlined';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import PinDropOutlinedIcon from '@mui/icons-material/PinDropOutlined';
import NumbersOutlinedIcon from '@mui/icons-material/NumbersOutlined';
import type { DenseIconKey } from './types';

const iconMap: Record<DenseIconKey, React.ComponentType<SvgIconProps>> = {
  calendar: ScheduleOutlinedIcon,
  capacity: ViewInArOutlinedIcon,
  cluster: CategoryOutlinedIcon,
  cost: CurrencyRupeeRoundedIcon,
  customer: SellOutlinedIcon,
  distance: StraightenOutlinedIcon,
  duration: AccessTimeOutlinedIcon,
  edit: EditOutlinedIcon,
  floor: NumbersOutlinedIcon,
  gmv: CurrencyRupeeRoundedIcon,
  hub: WarehouseIcon,
  location: PlaceOutlinedIcon,
  order: PinDropOutlinedIcon,
  percentage: PercentRoundedIcon,
  pin: RoomOutlinedIcon,
  slot: ScheduleOutlinedIcon,
  time: AccessTimeOutlinedIcon,
  touchPoint: PlaceOutlinedIcon,
  tote: Inventory2OutlinedIcon,
  vehicle: LocalShippingOutlinedIcon,
  volume: ViewInArOutlinedIcon,
  warning: WarningAmberOutlinedIcon,
  weight: ScaleOutlinedIcon,
};

export function renderDenseIcon(iconKey?: DenseIconKey, props?: SvgIconProps): React.ReactNode {
  if (!iconKey) return null;
  const IconComponent = iconMap[iconKey];
  return IconComponent ? <IconComponent {...props} /> : null;
}
